import { render, staticRenderFns } from "./WellImport.vue?vue&type=template&id=71502ee4"
import script from "./WellImport.vue?vue&type=script&lang=ts"
export * from "./WellImport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports